import { createContext } from "react";

export const localizedNamespaceContext = createContext(null);

export const { Provider } = localizedNamespaceContext;
